var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactsIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 378.5 182.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#c0d4f9;}.e{fill:#fff;}.f{fill:#79a1f6;}.g{stroke-width:.1px;}.g,.h,.i,.j,.k,.l{fill:none;stroke-miterlimit:10;}.g,.i,.l{stroke:#31193b;}.m{fill:#c9e1fb;font-family:UbuntuTitling-Bold, UbuntuTitling Bold;font-size:7.03px;}.n{fill:#4576ce;}.o{fill:#7aa2f7;}.p{fill:#e87d91;}.q{fill:#d5e5fc;}.r{fill:#4b5fa4;}.s{fill:#649df6;}.h,.j{stroke:#4b5fa4;}.h,.k{stroke-width:.25px;}.t{fill:#2c417c;}.u{fill:#4c60a5;}.v{fill:#31193b;}.i{stroke-width:.11px;}.j{stroke-width:.75px;}.w{fill:#637abe;}.k{stroke:#fff;}.x{fill:#f4e0eb;}.y{fill:#a4aee9;}.a`{fill:#d54066;}.aa{fill:#f990a1;}.ab{fill:#93c7f6;}.ac{fill:#6896ea;}.ad{fill:#2a2b7d;}.ae{fill:#2e3154;}.l{stroke-width:.19px;}.af{fill:#f3a9b8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M334.04,177.42s-19.18-11.7-10.11-23.2c9.24-11.71,21.1-4.45,17.34-19.34-3.77-14.89,2.21-20.06,13.57-21.12,11.36-1.06,4.43-18.86,15.2-17.47,10.77,1.39,10.25,11.33,4.05,21.74-6.21,10.41,6.05,11.2,.65,22.19-7.36,14.97-16.93,9.66-12.9,25.59,4.07,16.1-14.01,20.59-27.79,11.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "q",
    x: 230.7,
    y: 21.15,
    width: 68.06,
    height: 48.95,
    transform: "translate(11.62 -44.38) rotate(9.8)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "k",
    points: "236.05 16.46 264.39 47.61 301.53 27.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 262.19,
    y1: 45.19,
    x2: 227.93,
    y2: 63.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 293.41,
    y1: 74.8,
    x2: 267.25,
    y2: 46.04
  }))), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M132.14,94.33s-27.94-9.99-35.19-46.57c19.4,11.75,31.29,31.05,31.29,31.05,0,0-15.31-18.43-9.72-51.03,23.22,25.27,20.38,51.92,13.62,66.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M323.48,79.8c5.74-9,18.51-31.81,25.1-65.47-20.04,18.85-35.83,66.36-35.83,66.36,0,0,6.12-26.59-3.91-53.78-14.71,36.76-.56,75.96-.56,75.96,0,0,38.84-15.65,52.46-51.92-16.49,2.31-31.21,20.4-37.26,28.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M46.73,179.64s-17.71,8.5-29.89-8.33c-12.18-16.83,8.23-21.95-9.16-34.75-17.39-12.8,1.07-19.56-5.3-33.99-6.38-14.42,1.65-16.19,6.63-15.39,4.98,.8,7.94,17.28,18.91,17.72,10.98,.43,20.2,14.58,15.68,26.22-4.52,11.65,13.66,6.07,19.38,21.52,6.92,18.68-16.26,27-16.26,27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M150.36,53.49c-1.12-8.66-7.25-30.86,2.54-53.49,12.47,19.49,5.1,57.89,5.1,57.89,0,0,4.72-21.82,21.61-38.46-1.9,32.34-26.03,56.43-26.03,56.43,0,0-25.56-29.99-23.02-61.58,11.4,7.45,18.25,30.85,19.79,39.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M32.85,104.99l18.08-10.5c-3.83-2.26-7.82-3.97-8.84-10.46l-11.2,6.98,1.96,13.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M30.82,90.46l11.19-6.97c-.11-.88-.17-1.84-.17-2.89,0-4.74-.51-9.12-1.53-12.85l-11.73,6.77,2.23,15.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M43.56,181.39c18.78-2.6,31.77-17.81,19.59-32.13l-22.28,12.99,2.68,19.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M35.45,123.55l23.39-13.63c-.02-.91-.06-1.84-.14-2.82-.6-7.44-3.82-10.21-7.28-12.31l-18.5,10.74,2.53,18.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M40.8,161.72l22.02-12.84c-.4-.45-.8-.9-1.25-1.34-6.14-6.14-7.83-10.06-7.63-13.78l-15.68,9.83,2.54,18.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M7.02,162.07c-1.33,19.37,29.19,19.69,29.19,19.69,2.34,.09,4.64-.02,6.86-.3l-1.34-9.54-34.71-9.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M38.19,143.04l15.81-9.91c.59-5.5,5.01-10.84,4.86-22.64l-23.33,13.6,2.66,18.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M38.95,152.1l-25.32-6.52c-2.77,3.65-5.6,8.28-6.52,15.31-.03,.23-.03,.45-.06,.67l34.6,9.82-2.7-19.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M26.94,66.43l-10.78-3.14c-.36,4.33,2.52,9.76,3.38,14.96l9.44,2.75-2.04-14.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M29.06,81.55l-9.43-2.75c.53,3.85-.17,7.55-4.27,10.54-1.17,.86-2.27,1.72-3.28,2.6l19.23,5.66-2.25-16.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M25.45,55.78c-1.34,.25-2.76,.67-4.28,1.33-3.25,1.41-4.6,3.38-4.94,5.68l10.63,3.09-1.42-10.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M40.17,67.26c-2.29-7.84-6.97-12.64-14.22-11.56l2.56,18.29,11.66-6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M31.39,98.15l-19.75-5.81c-4.72,4.21-7.51,8.7-7.59,13.75l29.55,7.87-2.21-15.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M36.4,133.92l-18.81-5.17c5.18,7.13,.97,10.47-3.62,16.4l24.91,6.42-2.47-17.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M33.68,114.49l-29.62-7.89c.1,5.34,3.18,11.3,10.11,18.23,1.17,1.17,2.12,2.25,2.91,3.25l19.25,5.29-2.65-18.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M63.15,149.26c-.11-.13-.22-.26-.34-.38l-22.02,12.84-2.54-18.13,15.68-9.83c.01-.21,.03-.42,.06-.63l-15.81,9.91-2.66-18.96,23.33-13.6c0-.19,0-.38-.01-.57l-23.39,13.63-2.53-18.03,18.5-10.74c-.16-.1-.33-.2-.49-.29l-18.08,10.5-1.96-13.99,11.2-6.98c-.03-.18-.06-.35-.09-.54l-11.19,6.97-2.23-15.94,11.73-6.77c-.05-.17-.09-.33-.14-.5l-11.66,6.73-2.56-18.29c-.16,.02-.33,.06-.49,.09l1.42,10.11-10.63-3.09c-.02,.17-.05,.33-.07,.5l10.78,3.14,2.04,14.58-9.44-2.75c.03,.18,.06,.37,.09,.55l9.43,2.75,2.25,16.06-19.23-5.66c-.15,.13-.29,.26-.44,.39l19.75,5.81,2.21,15.8-29.55-7.87c0,.17,0,.35,0,.52l29.62,7.89,2.65,18.89-19.25-5.29c.17,.22,.36,.45,.51,.66l18.81,5.17,2.47,17.64-24.91-6.42c-.11,.14-.22,.29-.33,.43l25.32,6.52,2.7,19.28-34.6-9.82c-.02,.17-.03,.34-.04,.51l34.71,9.86,1.34,9.54c.17-.02,.33-.05,.5-.07l-2.68-19.14,22.28-12.99Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M345.42,66.32c-3.77-.53-7.91,2.02-10.29,12.46l7.03,5.74,3.26-18.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M352.64,74.64c.03-2.22-.22-3.99-1.21-4.98-1.42-1.42-3.39-2.79-5.51-3.25l-2,11.19,8.73-2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M341.11,93.21l11.1-3.76c-.66-4.9,.27-10.25,.41-14.28l-8.81,2.99-2.7,15.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M361.21,103.67l-23.39,7.93-2.59,14.44,28.46-9.65c.39-4.51-.44-9.03-2.48-12.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M337.92,111.04l23.04-7.81c-1.02-1.74-2.33-3.28-3.91-4.52-2.91-2.29-4.23-5.4-4.76-8.76l-11.28,3.82-3.09,17.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M338.99,102.23l-12.83-10.48c-4.12,2.91-8.37,5.14-9.95,9.86l19.98,16.32,2.81-15.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M342.06,85.08l-7.05-5.76s-.02,.08-.03,.12c-1.3,6.12-4.76,9.37-8.4,12l12.51,10.22,2.97-16.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M326.75,173.41l-1.31,7.29c4.98,1.16,26.69,5.01,32.08-14.35,.35-1.24,.56-2.43,.69-3.58l-31.45,10.66v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M333.33,133.84l-14.68-11.99c.32,5.96-2.44,8.71-5.77,11.38l17.93,14.65,2.51-14.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M326.85,172.88l31.41-10.65c.44-5.44-1.4-9.78-3.45-13.42l-25.18,8.54-2.78,15.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M336.08,118.49l-20.02-16.36c-.83,2.94-.68,6.8,1.08,12.31,.84,2.61,1.29,4.8,1.45,6.7l14.84,12.13,2.65-14.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M328.04,163.38l-24.21-19.77c-.92,2.39-1.5,5.33-1.5,9.12,0,2.45,.25,4.68,.67,6.73l22.45,18.34,2.58-14.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M303.18,160.24c4.02,17.07,21.23,20.2,21.23,20.2,0,0,.2,.06,.55,.14l.4-2.22-22.18-18.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M330.72,148.44l-18.23-14.89c-3.04,2.4-6.46,4.85-8.45,9.58l24.1,19.69,2.58-14.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M329.73,156.78l24.83-8.42c-2.93-5.1-6.04-8.86-3.27-12.5l-18.96,6.43-2.6,14.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M332.43,141.73l19.52-6.62c.54-.55,1.21-1.09,2.06-1.64,5.74-3.71,8.93-10.06,9.63-16.52l-28.5,9.66-2.71,15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M337.82,111.6l23.39-7.93c-.08-.15-.16-.3-.25-.44l-23.04,7.81,3.09-17.27,11.28-3.82c-.03-.17-.06-.33-.08-.5l-11.1,3.76,2.7-15.05,8.81-2.99c0-.18,.01-.36,.01-.53l-8.73,2.96,2-11.19c-.16-.03-.33-.07-.49-.09l-3.26,18.2-7.03-5.74c-.04,.18-.08,.36-.13,.54l7.05,5.76-2.97,16.58-12.51-10.22c-.14,.1-.28,.2-.42,.3l12.83,10.48-2.81,15.7-19.98-16.32c-.06,.17-.1,.35-.15,.52l20.02,16.36-2.65,14.78-14.84-12.13c.02,.23,.05,.48,.07,.7l14.68,11.99-2.51,14.04-17.93-14.65c-.13,.11-.26,.21-.4,.32l18.23,14.89-2.58,14.38-24.1-19.69c-.07,.16-.14,.31-.2,.48l24.21,19.77-2.58,14.41-22.45-18.34c.05,.27,.11,.53,.17,.79l22.18,18.12-.4,2.22c.14,.03,.3,.07,.49,.12l1.31-7.29v.03l31.46-10.66c.02-.18,.03-.36,.05-.54l-31.41,10.65,2.78-15.53,25.18-8.54c-.08-.15-.17-.3-.25-.44l-24.83,8.42,2.6-14.49,18.96-6.43c.19-.25,.41-.5,.66-.75l-19.52,6.62,2.71-15.12,28.5-9.66c.02-.18,.04-.36,.05-.55l-28.46,9.65,2.59-14.44Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 128.14,
    y: 52.08,
    width: 180.37,
    height: 129.73
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "k",
    points: "130.28 53.7 218.33 122.28 306.38 53.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 211.48,
    y1: 116.95,
    x2: 130.28,
    y2: 180.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 306.38,
    y1: 180.2,
    x2: 225.09,
    y2: 116.88
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 291.69,
    y: 98.39,
    width: 47.51,
    height: 83.4,
    rx: 3.47,
    ry: 3.47,
    transform: "translate(630.88 280.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    x: 293.27,
    y: 104.91,
    width: 44.35,
    height: 70.36
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M109.98,109.55v-16.54l-7.89-2.12v13h-30.22v-13l-7.89,2.12v16.54s-28.69,23.98-28.69,46.9v18.52h103.38v-18.52c0-22.92-28.69-46.9-28.69-46.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 86.97,
    cy: 137.93,
    r: 22.7,
    transform: "translate(-70.63 179.78) rotate(-72.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M86.97,82.42c-78.18,0-69.09,26.23-69.09,26.23H50.35c0-16.62,36.62-16.62,36.62-16.62,0,0,36.62,0,36.62,16.62h32.47s9.09-26.23-69.09-26.23Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 15.64,
    y: 106.51,
    width: 37.03,
    height: 10.93,
    rx: 2.2,
    ry: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 121.28,
    y: 106.51,
    width: 37.03,
    height: 10.93,
    rx: 2.2,
    ry: 2.2
  })), /*#__PURE__*/React.createElement("circle", {
    className: "r",
    cx: 86.97,
    cy: 137.93,
    r: 12.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 69.93,
    cy: 137.93,
    r: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M72.1,146.73c-1.19,1-1.35,2.78-.35,3.97,1,1.19,2.78,1.35,3.97,.35,1.19-1,1.35-2.78,.35-3.97s-2.78-1.35-3.97-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M81.24,154.23c-.27,1.53,.75,2.99,2.29,3.26s2.99-.75,3.26-2.29-.75-2.99-2.29-3.26c-1.53-.27-2.99,.75-3.26,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M93.06,154.1c.78,1.35,2.5,1.81,3.85,1.03,1.35-.78,1.81-2.5,1.03-3.85-.78-1.35-2.5-1.81-3.85-1.03-1.35,.78-1.81,2.5-1.03,3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M102.03,146.41c1.46,.53,3.08-.22,3.61-1.68,.53-1.46-.22-3.08-1.68-3.61s-3.08,.22-3.61,1.68c-.53,1.46,.22,3.08,1.68,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M103.96,134.75c1.46-.53,2.22-2.15,1.68-3.61-.53-1.46-2.15-2.22-3.61-1.68-1.46,.53-2.22,2.15-1.68,3.61,.53,1.46,2.15,2.22,3.61,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M72.1,146.73c-1.19,1-1.35,2.78-.35,3.97,1,1.19,2.78,1.35,3.97,.35,1.19-1,1.35-2.78,.35-3.97s-2.78-1.35-3.97-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M97.94,124.57c.78-1.35,.32-3.07-1.03-3.85-1.35-.78-3.07-.32-3.85,1.03-.78,1.35-.32,3.07,1.03,3.85,1.35,.78,3.07,.32,3.85-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M81.24,154.23c-.27,1.53,.75,2.99,2.29,3.26s2.99-.75,3.26-2.29-.75-2.99-2.29-3.26c-1.53-.27-2.99,.75-3.26,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M86.79,120.65c-.27-1.53-1.73-2.56-3.26-2.29-1.53,.27-2.56,1.73-2.29,3.26,.27,1.53,1.73,2.56,3.26,2.29s2.56-1.73,2.29-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M93.06,154.1c.78,1.35,2.5,1.81,3.85,1.03,1.35-.78,1.81-2.5,1.03-3.85-.78-1.35-2.5-1.81-3.85-1.03-1.35,.78-1.81,2.5-1.03,3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M75.73,124.81c-1.19-1-2.97-.84-3.97,.35-1,1.19-.84,2.97,.35,3.97,1.19,1,2.97,.84,3.97-.35s.84-2.97-.35-3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M35.18,168.13h103.6c.56,0,1.02,.46,1.02,1.02v11.62c0,.56-.46,1.02-1.02,1.02H35.18c-.56,0-1.02-.46-1.02-1.02v-11.62c0-.56,.46-1.02,1.02-1.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a`",
    d: "M315.7,134.78s-5.77,.48-7.05,6.12c-1.27,5.64-.41,9.38-.41,9.38h14.92s1.75-15.5-7.46-15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M319.06,153.97h-6.82s-11.54,.83-11.54,21.31h29.91c0-20.47-11.54-21.31-11.54-21.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M307.95,163.24l-4.43-2.27s1.36-6.57,6.95-6.57c0,0,.33,4.96-2.53,8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M323.4,163.24l4.43-2.27s-1.36-6.57-6.95-6.57c0,0-.33,4.96,2.53,8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M321,154.94l-.14-.54-1.62-.63,.85,9.82c-2.29-.43-6.73-.5-8.78,.18l.77-10-1.62,.63-.73,2.9c-.67,2-1.26,3.99-2.1,5.94-.46,1.07-1.04,2.07-1.43,3.17-.84,2.4-.04,5.97,1.49,8.12,.18,.26,.38,.52,.61,.74h14.77c.18,0,1.14-1.59,1.23-1.76,2.75-5.28,.3-7.59-1.22-11.61-.86-2.27-1.51-4.61-2.1-6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M315.67,157.54h0c1.98,0,3.58-1.6,3.58-3.58v-5.96h-7.16v5.96c0,1.98,1.6,3.58,3.58,3.58Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M309.91,142.5s-1.95-.2-1.95,1.78,2.51,2.19,2.51,2.19l-.56-3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M321.43,142.5s1.95-.2,1.95,1.78-2.51,2.19-2.51,2.19l.56-3.97Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M315.67,151.57h0c3.2,0,5.83-2.62,5.83-5.83v-3.24c0-3.2-2.62-5.83-5.83-5.83h0c-3.2,0-5.83,2.62-5.83,5.83v3.24c0,3.2,2.62,5.83,5.83,5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a`",
    d: "M314.1,147.82s.86-.54,1.57,.11c.73-.68,1.54-.07,1.54-.07,0,0-.39,.92-1.5,.92-1.37,0-1.6-.96-1.6-.96Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "v",
    cx: 313.2,
    cy: 144.25,
    rx: 0.45,
    ry: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M317.69,144.26c0,.41,.2,.75,.45,.75s.45-.34,.45-.75-.2-.75-.45-.75-.45,.34-.45,.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M313.68,147.56s.55,.63,1.99,.63,2.07-.63,2.07-.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M315.67,144.18s-1.58,2.82,0,2.82,0-2.82,0-2.82Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M312.52,142.92s.47-.55,1.35-.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M318.83,142.93s-.47-.55-1.35-.41"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M310.16,146.47c0,.95,.77,1.72,1.72,1.72s1.72-.77,1.72-1.72-.77-1.72-1.72-1.72-1.72,.77-1.72,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M317.82,146.47c0,.95,.77,1.72,1.72,1.72s1.72-.77,1.72-1.72-.77-1.72-1.72-1.72-1.72,.77-1.72,1.72Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M308.65,143.59s.87,.02,.87,1.23c-.49,.49,0,.77,0,.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M322.66,143.59s-.87,.02-.87,1.23c.49,.49,0,.77,0,.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M315.05,146.68s.21,.32,.62,.32,.62-.32,.62-.32"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M308.96,143.01s-.21-7.66,6.71-7.66,6.63,7.71,6.63,7.71h.83s.71-8.65-7.49-8.65-7.39,8.61-7.39,8.61h.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M309.18,146.38s-1.52,0-1.52-1.93,1.48-1.96,1.48-1.96l.04,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M322.12,146.38s1.52,0,1.52-1.93-1.48-1.96-1.48-1.96l-.04,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M319.48,149.15h0c-.06-.06-.06-.15,0-.21l3.15-3.15c.06-.06,.15-.06,.21,0h0c.06,.06,.06,.15,0,.21l-3.15,3.15c-.06,.06-.15,.06-.21,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    x: 318.76,
    y: 148.82,
    width: 1.31,
    height: 0.79,
    rx: 0.34,
    ry: 0.34,
    transform: "translate(-11.95 269.57) rotate(-45)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a`",
    d: "M309.69,142.5s3.83,.27,5.96-4.57c2.16,4.91,6.14,4.6,6.14,4.6,0,0-.13-6.87-6.14-6.87s-5.96,6.84-5.96,6.84Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 317.96,
    y: 166.23,
    width: 6.11,
    height: 3.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M321.02,166.73h0c.09,0,.16-.07,.16-.16v-.69c0-.09-.07-.16-.16-.16h0c-.09,0-.16,.07-.16,.16v.69c0,.09,.07,.16,.16,.16Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M69.19,75.6s1.73-2.09,12.36,.66h10.48s8.55-3.67,11.96-.71c-16.73,6.63-17.64,6.84-17.64,6.84l-17.15-6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M84.34,56.49s-6.64,1.88-10.59,8.08,.8,9.82,6.07,12.43c.31-1.38,.17-1.24,.17-1.24,0,0-4.86-4.82-4.5-7.16,0,0,8.84-7.66,8.84-12.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M89.08,56.49s6.64,1.88,10.59,8.08c3.95,6.19-.8,9.82-6.07,12.43-.31-1.38-.17-1.24-.17-1.24,0,0,4.86-4.82,4.5-7.16,0,0-8.84-7.66-8.84-12.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a`",
    d: "M75.35,62.43s.14,2.22,2.97,3.49c3.71-1.83,6.29-6.66,6.29-9.71-3.38-.32-8.81,4.65-9.26,6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a`",
    d: "M98,62.43s-.14,2.22-2.97,3.49c-3.71-1.83-6.29-6.66-6.29-9.71,3.38-.32,8.81,4.65,9.26,6.22Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a`",
    d: "M94.26,63.42c1.71-3.09-2.18-5.43-3.89-6.38-1.02-.56-2.17-.83-3.34-.83h-.7c-1.16,0-2.32,.26-3.34,.83-1.71,.95-5.61,3.29-3.89,6.38,1.76,3.15,1.92,9.03,1.34,12.85h12.05c-.59-3.56-.34-9.03,1.77-12.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M92.48,76.26h-12.05c-.29,1.94-.77,3.35-1.34,3.58l6.74,3.49h1.67l6.74-3.49c-.75,.07-1.42-1.4-1.77-3.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M86.67,58.65h0c1.14,0,2.07-.93,2.07-2.07v-3.45h-4.14v3.45c0,1.14,.93,2.07,2.07,2.07Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M83.35,49.95s-1.13-.12-1.13,1.03,1.45,1.26,1.45,1.26l-.33-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M90,49.95s1.13-.12,1.13,1.03-1.45,1.26-1.45,1.26l.33-2.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M86.67,55.19h0c1.85,0,3.37-1.52,3.37-3.37v-1.87c0-1.85-1.52-3.37-3.37-3.37h0c-1.85,0-3.37,1.52-3.37,3.37v1.87c0,1.85,1.52,3.37,3.37,3.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    x: 78.31,
    y: 69.77,
    width: 16.09,
    height: 9.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M93.1,85.65s-20.39-14.44-24.17-9.84c-4.6,5.6,23.19,11.99,23.19,11.99l.98-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M80.15,85.65s20.06-14.15,24.17-9.84c5.07,5.32-23.26,11.99-23.26,11.99l-.91-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M80.15,85.65s-3.61-.49-3.61,1.02,4.52,1.13,4.52,1.13l-.91-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M93.03,85.65s3.61-.49,3.61,1.02-4.52,1.13-4.52,1.13l.91-2.15Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M84.98,50.92c0,.25,.12,.45,.27,.45s.27-.2,.27-.45-.12-.45-.27-.45-.27,.2-.27,.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M87.84,50.92c0,.25,.12,.45,.27,.45s.27-.2,.27-.45-.12-.45-.27-.45-.27,.2-.27,.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M85.52,52.87s.32,.37,1.15,.37,1.2-.37,1.2-.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M86.67,52.55v-1.63s-1.26,1.63,0,1.63Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M84.85,50.19s.27-.32,.78-.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M88.5,50.2s-.27-.32-.78-.24"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M83.49,52.25c0,.55,.45,.99,.99,.99s.99-.45,.99-.99-.45-.99-.99-.99-.99,.45-.99,.99Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "p",
    cx: 88.91,
    cy: 52.25,
    r: 0.99
  })), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M86.67,45.34s-2.78-.08-3.71,2.52c-.94,2.6,.53,3.51,.53,3.51,0,0,.2-1.95,1.75-2.87,.46,1.2,1.58,1.45,1.58,1.45,0,0,1.6-.39,2-1.97,.66,1.42,1.38,3.12,1.38,3.12,0,0,.62-.61,.36-2.28-.26-1.67-1.27-3.48-3.88-3.48Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M82.83,50.17s-.12-4.39,3.85-4.39,3.8,4.41,3.8,4.41h.48s.41-4.95-4.29-4.95-4.23,4.93-4.23,4.93h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M82.96,52.1s-.87,0-.87-1.11,.85-1.12,.85-1.12l.03,2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M90.37,52.1s.87,0,.87-1.11-.85-1.12-.85-1.12l-.03,2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M88.86,53.69h0s-.03-.09,0-.12l1.81-1.81s.09-.03,.12,0h0s.03,.09,0,.12l-1.81,1.81s-.09,.03-.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M89.11,53.76l-.26,.26c-.08,.08-.2,.08-.27,0l-.05-.05c-.08-.08-.08-.2,0-.27l.26-.26c.08-.08,.2-.08,.27,0l.05,.05c.08,.08,.08,.2,0,.27Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M277.76,16.4s-2.68,.07-3.44,2.05c-.76,1.98-.44,3.37-1.23,5.27-.57,1.36-.47,3.21,1.94,3.85,2.41,.63,6.55,.34,7.37-1.55,.82-1.88-1.01-3.17-.9-4.66,.11-1.49-.24-4.96-3.74-4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M283.35,46.29c-.06-.34-.11-.66-.15-.94l-18.79-.57c-5.66,0,3.28,18.21,5.48,22.67,0,0-.43,5.16,.85,4.68,2.03-.76,2.21-6.12,1.24-8.89-.11-.31-.22-.63-.28-.95-.76-3.74-1.46-7.21-2.23-10.06,2.04,.49,4.48,.63,6.74,.63,5.61,0,7.87-2.44,7.14-6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a`",
    d: "M284.86,33.28c1.61-2.9-2.05-5.1-3.66-5.99-.96-.53-2.04-.78-3.13-.78h-.66c-1.09,0-2.18,.25-3.13,.78-1.61,.89-5.27,3.09-3.66,5.99,1.65,2.96,1.8,8.48,1.26,12.07h11.31c-.55-3.35-.32-8.48,1.67-12.07Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M266.76,33.83c-3.71,5.82,.75,7.73,5.7,10.18,.29-1.29,.16-1.16,.16-1.16,0,0-3.19-3.33-4.22-5.23,0,0,.84-.73,1.98-1.85l-2.73-3.19c-.31,.4-.61,.81-.89,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a`",
    d: "M276.7,26.24s-5.32,1.52-9.05,6.34l2.73,3.19c2.46-2.42,6.32-6.67,6.32-9.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M289.51,36.88c-.43-1.15-.98-2.18-1.57-3.11l-2.96,3.37c1.17,1.83,2.15,3.13,2.15,3.13-1.02,1.73-5.2,4.26-5.2,4.26,0,0-.1-.15-.08,1.17,5.34-1.39,10.1-2.36,7.66-8.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a`",
    d: "M281.32,27.42c-.52,2.52,1.79,6.79,3.65,9.71l2.96-3.37c-2.74-4.31-6.62-6.34-6.62-6.34Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M277.74,28.8h0c1.07,0,1.94-.87,1.94-1.94v-3.24h-3.89v3.24c0,1.07,.87,1.94,1.94,1.94Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M274.62,20.63s-1.06-.11-1.06,.97,1.37,1.19,1.37,1.19l-.31-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M280.87,20.63s1.06-.11,1.06,.97-1.37,1.19-1.37,1.19l.31-2.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M277.74,25.55h0c1.74,0,3.16-1.42,3.16-3.16v-1.76c0-1.74-1.42-3.16-3.16-3.16h0c-1.74,0-3.16,1.42-3.16,3.16v1.76c0,1.74,1.42,3.16,3.16,3.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    x: 267.02,
    y: 36.44,
    width: 15.11,
    height: 9.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M276.89,23.51s.47-.29,.85,.06c.4-.37,.83-.04,.83-.04,0,0-.21,.5-.82,.5-.74,0-.87-.52-.87-.52Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M276.15,21.54c0,.23,.11,.42,.25,.42s.25-.19,.25-.42-.11-.42-.25-.42-.25,.19-.25,.42Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "ad",
    cx: 279.09,
    cy: 21.54,
    rx: 0.25,
    ry: 0.42
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M276.66,23.37s.3,.34,1.08,.34,1.13-.34,1.13-.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M277.74,23.07v-1.53s-1.18,1.53,0,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M269.84,68.81s-.05,1.04,.64,1.15c1.87,.31,.58-5,1.92-4.89,.54,4.4-.64,6.61-1.64,7.16-1,.56-1.24-.79-.93-3.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "t",
    points: "269.55 66.35 272.54 65.13 271.95 62.93 268.51 64.27 269.55 66.35"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M276.03,20.86s.26-.3,.74-.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M279.46,20.86s-.26-.3-.74-.22"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M274.75,22.79c0,.52,.42,.93,.93,.93s.93-.42,.93-.93-.42-.93-.93-.93-.93,.42-.93,.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M278.91,22.79c0,.52,.42,.93,.93,.93s.93-.42,.93-.93-.42-.93-.93-.93-.93,.42-.93,.93Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M283.35,46.29c-2.03-1.11-6.37-1.57-9.27-1.7-1.25-.06-2.46,.57-3.06,1.67-2.93,5.32-4.13,20.76-4.13,20.76,0,0-3.06,4.36-1.69,4.49,2.31,.22,4.73-4.62,5.79-7.78,1.43-4.07,2.77-7.82,3.6-10.9,6.54,1.16,9.42-.95,8.76-6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M266.18,68.11s-.55,.88,0,1.32c1.48,1.18,2.98-4.06,4.1-3.31-1.67,4.11-3.82,5.44-4.96,5.44s-.7-1.29,.86-3.44Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M274.1,20.9s-.12-4.16,3.65-4.16,3.6,4.19,3.6,4.19h.45s.39-4.7-4.07-4.7-4.02,4.67-4.02,4.67h.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M274.22,22.73s-.83,0-.83-1.05,.8-1.07,.8-1.07l.02,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M281.25,22.73s.83,0,.83-1.05-.8-1.07-.8-1.07l-.02,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M279.81,24.23h0s-.03-.08,0-.11l1.71-1.71s.08-.03,.11,0h0s.03,.08,0,.11l-1.71,1.71s-.08,.03-.11,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    x: 279.42,
    y: 24.05,
    width: 0.71,
    height: 0.43,
    rx: 0.18,
    ry: 0.18,
    transform: "translate(64.79 204.94) rotate(-45)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M274.39,20.63s2.73,.4,5.07-2.3c.85,2.18,1.45,2.32,1.63,2.32s-.25-3.62-3.4-3.62-3.3,3.6-3.3,3.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "t",
    points: "266.79 66.58 269.95 67.18 270.66 65.02 267.04 64.27 266.79 66.58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "s",
    points: "267.03 18.98 269.65 21.59 269.65 17.99"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    x: 257.91,
    y: 10.17,
    width: 13.86,
    height: 9.05,
    rx: 3.25,
    ry: 3.25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M260.93,14.73c0,.39,.32,.71,.71,.71s.71-.32,.71-.71-.32-.71-.71-.71-.71,.32-.71,.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M267.32,14.73c0,.39,.32,.71,.71,.71s.71-.32,.71-.71-.32-.71-.71-.71-.71,.32-.71,.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M264.13,14.73c0,.39,.32,.71,.71,.71s.71-.32,.71-.71-.32-.71-.71-.71-.71,.32-.71,.71Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M175.6,114.42s5.83-1.23,9.66,8.19c3.48-5.07,4.54-7.25,4.54-7.25l1.33,.72s-2.03,10.48-5.1,10.48-7.66-4.6-7.66-4.6l-2.76-7.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M171.32,114.46s-6.85-.41-9.91,13.69c-3.07,14.1-2.76,17.78-2.76,17.78h1.64s9.43-23.53,11.03-31.47Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M181.64,122.84c0-9.81-5.41-8.38-10.32-8.38s-4.7,8.38-4.7,8.38l-.96,16.73h15.98v-16.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "a`",
    points: "165.66 139.57 163.35 179.95 166.99 179.95 173.77 146.14 177.76 179.95 181.4 179.95 181.64 139.57 165.66 139.57"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M181.64,179.95s2.09-.26,4.19,1.84h-7.97l-.1-1.84h3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M163.11,179.95s-2.09-.26-4.19,1.84h7.97l.1-1.84h-3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M172.05,113.87l2.07,3.18s-1.7,1.25-2.8-.4c-1.09-1.65,.72-2.78,.72-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M176.19,113.87l-2.06,3.18s1.69,1.25,2.78-.4c1.09-1.65-.72-2.78-.72-2.78Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M170.81,107.58s-1.1-.12-1.1,1.03,1.41,1.26,1.41,1.26l-.32-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M177.44,107.58s1.1-.12,1.1,1.03-1.41,1.26-1.41,1.26l.32-2.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M174.13,117.05h0c-1.14,0-2.07-.93-2.07-2.07v-3.45h4.14v3.45c0,1.14-.93,2.07-2.07,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M174.13,113.05h0c-1.85,0-3.37-1.52-3.37-3.37v-2.66c0-1.85,1.52-3.37,3.37-3.37h0c1.85,0,3.37,1.52,3.37,3.37v2.66c0,1.85-1.52,3.37-3.37,3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M170.76,109.29s.7-1.61,.7-4.15c2.11,1.33,5.43,0,5.43,0,0,0-.15,2.79,.62,4.14,1.17-2.47,.72-6.52-3.37-6.52s-4.48,4.03-3.37,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M160.32,145.64s.56,3.06,.09,3.37c-.4,.23-.59-1.68-.59-1.68,0,0-.4,1.77-.49,2.68-.09,.9-1.19,.76-1.46-.97-.27-1.73,.96-3.37,.96-3.37l1.5-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M189.74,115.52s.68-3.04,1.23-3.14c.46-.06-.11,1.78-.11,1.78,0,0,1.06-1.48,1.49-2.27,.43-.79,1.39-.23,.97,1.47-.43,1.7-2.19,2.73-2.19,2.73l-1.38-.57Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M172.42,108.45c0,.25,.12,.45,.27,.45s.27-.2,.27-.45-.12-.45-.27-.45-.27,.2-.27,.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M175.28,108.45c0,.25,.12,.45,.27,.45s.27-.2,.27-.45-.12-.45-.27-.45-.27,.2-.27,.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M172.97,110.4s.32,.37,1.15,.37,1.2-.37,1.2-.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M174.11,110.08v-1.63s-1.26,1.63,0,1.63Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M172.3,107.72s.27-.32,.78-.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M175.95,107.72s-.27-.32-.78-.24"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M170.93,109.77c0,.55,.45,.99,.99,.99s.99-.45,.99-.99-.45-.99-.99-.99-.99,.45-.99,.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M175.36,109.77c0,.55,.45,.99,.99,.99s.99-.45,.99-.99-.45-.99-.99-.99-.99,.45-.99,.99Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "165.73 138.47 181.64 138.47 181.64 139.61 165.66 139.61 165.73 138.47"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M170.29,107.84s-.12-4.39,3.85-4.39,3.8,4.41,3.8,4.41h.48s.41-4.95-4.29-4.95-4.23,4.93-4.23,4.93h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M170.42,109.77s-.87,0-.87-1.11,.85-1.12,.85-1.12l.03,2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M177.83,109.77s.87,0,.87-1.11-.85-1.12-.85-1.12l-.03,2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M176.32,111.36h0s-.03-.09,0-.12l1.81-1.81s.09-.03,.12,0h0s.03,.09,0,.12l-1.81,1.81s-.09,.03-.12,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    x: 175.91,
    y: 111.17,
    width: 0.75,
    height: 0.45,
    rx: 0.19,
    ry: 0.19,
    transform: "translate(-27.13 157.28) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "s",
    points: "184.3 101.49 181.68 104.1 181.68 100.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    x: 179.56,
    y: 92.68,
    width: 13.86,
    height: 9.05,
    rx: 3.25,
    ry: 3.25,
    transform: "translate(372.98 194.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M190.4,97.24c0,.39-.32,.71-.71,.71s-.71-.32-.71-.71,.32-.71,.71-.71,.71,.32,.71,.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M184.01,97.24c0,.39-.32,.71-.71,.71s-.71-.32-.71-.71,.32-.71,.71-.71,.71,.32,.71,.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M187.21,97.24c0,.39-.32,.71-.71,.71s-.71-.32-.71-.71,.32-.71,.71-.71,.71,.32,.71,.71Z"
  }))), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 174.13,
    y1: 117.05,
    x2: 174.13,
    y2: 138.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 173.08,
    y: 138.33,
    width: 2.09,
    height: 1.39
  })), /*#__PURE__*/React.createElement("circle", {
    className: "s",
    cx: 315.62,
    cy: 120.63,
    r: 9.86,
    transform: "translate(25.83 294.38) rotate(-51.86)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "y",
    x: 172.85,
    y: 33.55,
    width: 41.16,
    height: 29.6,
    transform: "translate(-5.56 35.85) rotate(-10.44)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "k",
    points: "171.05 37.8 193.64 49.55 210.57 30.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 191.89,
    y1: 48.64,
    x2: 176.28,
    y2: 66.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 215.8,
    y1: 58.91,
    x2: 194.94,
    y2: 48.06
  }))), /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "translate(308.59 123.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "24/7")), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 157.83,
    y1: 139.02,
    x2: 158.88,
    y2: 139.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "j",
    x1: 2.12,
    y1: 181.79,
    x2: 376.38,
    y2: 181.79
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsIllustration);
export default __webpack_public_path__ + "static/media/contacts-illustration.ea3d50fe9c13b41419a040a524bbdd47.svg";
export { ForwardRef as ReactComponent };